module.exports = __webpack_public_path__ + "img/on-going-creat-new-team.ee478972.png";